import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { ComponentsModule } from "../../components/form-components.module";
import { LoginComponent } from "./login.component";
import { HttpService } from "src/providers/http.service";
import { RouterModule } from "@angular/router";

@NgModule({
    imports: [ ComponentsModule, RouterModule ],
    declarations: [LoginComponent],
    providers: [ HttpService ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
  })

  export class LoginModule {}
